export enum UserVirtualGroupTypeEnumerator {
  TUTOR = 1,
  STUDENT = 2,
}